// extracted by mini-css-extract-plugin
export default {"dialogTitle":"dialog_dialogTitle__JhW0x","dialogBody":"dialog_dialogBody__pg24R","dialog":"dialog_dialog__bMe7Y"};